"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRequirementsComponent = (0, vue_1.resolveComponent)("CardRequirementsComponent");
    const _component_CardRenderData = (0, vue_1.resolveComponent)("CardRenderData");
    const _component_CardDescription = (0, vue_1.resolveComponent)("CardDescription");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(["card-content", _ctx.corporationClass])
    }, [
        (_ctx.requirements.length > 0)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRequirementsComponent, {
                key: 0,
                requirements: _ctx.requirements
            }, null, 8, ["requirements"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.firstRow !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderData, {
                key: 1,
                renderData: _ctx.firstRow
            }, null, 8, ["renderData"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isCorporation && _ctx.hasDescription)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardDescription, {
                key: 2,
                item: _ctx.metadata.description
            }, null, 8, ["item"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.remainingRows !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderData, {
                key: 3,
                renderData: _ctx.remainingRows
            }, null, 8, ["renderData"]))
            : (0, vue_1.createCommentVNode)("", true),
        (!_ctx.isCorporation && _ctx.hasDescription)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardDescription, {
                key: 4,
                item: _ctx.metadata.description
            }, null, 8, ["item"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.bottomPadding)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 5,
                class: (0, vue_1.normalizeClass)('bottom-padding-' + _ctx.bottomPadding)
            }, null, 2))
            : (0, vue_1.createCommentVNode)("", true)
    ], 2));
}
